import React from 'react'
import Box from '@mui/material/Box'
import Modal from '@/v2/components/common/Modal'
import Wrapper from '@/v2/components/common/Wrapper'
import { useConsentFormsDetails } from '@/v2/hooks/documents/useConsentForm'

const ConsentFormDetails = ({ isOpen, id, signature, onClose }) => {
  const { consentForm } = useConsentFormsDetails(id)

  return (
    <Modal
      fullWidth
      isOpen={isOpen}
      title={consentForm?.title || 'Consent Form Details'}
      confirmLabel="Close"
      showClose={false}
      onConfirm={onClose}
      onClose={onClose}
      maxWidth="md"
    >
      <Wrapper>
        {/* contentHtml is sanitised on the server and is the same rendering
            the patient signs and the archived PDF carries. Not a div: Wrapper
            lays its direct div children out as a flex row. */}
        <Box
          component="article"
          sx={{
            typography: 'body2',
            '& p': { my: 1 },
            '& p:first-of-type': { mt: 0 },
          }}
          dangerouslySetInnerHTML={{ __html: consentForm?.contentHtml || '' }}
        />

        {signature && (
          <img src={signature} style={{ width: '140px', margin: '0 auto' }} />
        )}
      </Wrapper>
    </Modal>
  )
}

export default ConsentFormDetails
